import { Label } from '@/components/ui/label';

export function GroupsSection({ form, index, figures, updateGradeForm, updateGradeFormGroup, formatFigureDisplay }) {
  return (
    <div className="mb-4 p-4 border rounded-lg bg-green-50">
      <h4 className="font-medium mb-3 text-green-800">Groups Configuration</h4>
      
      {/* Number of Groups and Circuits per Figure - side by side */}
      <div className="grid grid-cols-2 gap-6 mb-4">
        {/* Number of Groups */}
        <div>
          <Label>Number of Groups *</Label>
          <div className="flex gap-4 mt-2">
            {[1, 2, 3, 4].map(num => (
              <label key={num} className="flex items-center gap-2 cursor-pointer">
                <input 
                  type="radio" 
                  name={`num-groups-${index}`} 
                  value={num} 
                  checked={form.num_groups === num} 
                  onChange={() => updateGradeForm(index, 'num_groups', num)}
                />
                <span>{num}</span>
              </label>
            ))}
          </div>
        </div>
        
        {/* Circuits per Figure */}
        <div>
          <Label>Circuits per Figure</Label>
          <div className="flex flex-col gap-1 mt-2">
            {['2 per figure', '3 per figure', '3 per figure & 2 per Paragraph', 'As Indicated'].map(option => (
              <label key={option} className="flex items-center gap-2 cursor-pointer">
                <input 
                  type="radio" 
                  name={`circuits-per-figure-${index}`} 
                  value={option} 
                  checked={form.circuits_per_figure === option} 
                  onChange={() => updateGradeForm(index, 'circuits_per_figure', option)}
                />
                <span className="text-sm">{option === 'As Indicated' ? 'As Indicated (in Judges Notes)' : option}</span>
              </label>
            ))}
          </div>
        </div>
      </div>
      
      {/* Group sections */}
      {form.num_groups && Array.from({ length: form.num_groups }, (_, groupIdx) => (
        <div key={groupIdx} className="mb-4 p-3 border rounded bg-white">
          <h5 className="font-medium mb-3">Group {groupIdx + 1}</h5>
          {[1, 2, 3, 4].map(figNum => {
            const figField = `figure_${figNum}_id`;
            const footField = `figure_${figNum}_foot`;
            const groupKey = `group_${groupIdx + 1}`;
            const selectedFigureId = form[groupKey]?.[figField];
            const selectedFigure = figures.find(f => f.figure_id === selectedFigureId);
            const currentFoot = form[groupKey]?.[footField] || selectedFigure?.default_starting_foot || 'Either';
            
            return (
              <div key={figNum} className="flex items-center gap-3 mb-3">
                <span className="w-8 text-center font-medium text-muted-foreground">{figNum}</span>
                <select 
                  className="flex-1 min-w-0 border rounded px-3 py-2 text-sm"
                  value={selectedFigureId || ''}
                  onChange={(e) => {
                    const fig = figures.find(f => f.figure_id === e.target.value);
                    updateGradeFormGroup(index, groupIdx + 1, figField, e.target.value);
                    if (fig) {
                      updateGradeFormGroup(index, groupIdx + 1, footField, fig.default_starting_foot);
                    }
                  }}
                >
                  <option value="">Select Figure</option>
                  {figures.map(fig => (
                    <option key={fig.figure_id} value={fig.figure_id}>
                      {formatFigureDisplay(fig, form[groupKey]?.[footField] || fig.default_starting_foot)}
                    </option>
                  ))}
                </select>
                <div className="flex items-center gap-3 shrink-0">
                  {['R', 'L', 'Either'].map(foot => (
                    <label key={foot} className="flex items-center gap-1 cursor-pointer">
                      <input 
                        type="radio" 
                        name={`foot-${index}-${groupIdx}-${figNum}`}
                        value={foot === 'R' ? 'Right' : foot === 'L' ? 'Left' : 'Either'}
                        checked={currentFoot === (foot === 'R' ? 'Right' : foot === 'L' ? 'Left' : 'Either')}
                        onChange={(e) => updateGradeFormGroup(index, groupIdx + 1, footField, e.target.value)}
                        disabled={!selectedFigureId}
                      />
                      <span className="text-sm">{foot}</span>
                    </label>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
}
